import withErrorHandler from '../../../modules/error/ErrorHandlerWrapper';
import OrderStatusBlock, { OrderStatusBlockProps } from './OrderStatusBlock';
import withInteractor from './OrderStatusBlock.interactor';
import withPresenter from './OrderStatusBlock.presenter';

export type { OrderStatusBlockProps };
export default withInteractor(withPresenter(withErrorHandler(OrderStatusBlock)));
